const TEXT_ALIGN = { left: "start", center: "center", right: "end" };

export const getAlignmentClasses = ({ textAlignment = "left", horizontalAlignment = "start", verticalAlignment = "start" }) => {
    const classes = { textAlignmentClass: "", horizontalAlignmentClass: "", verticalAlignmentClass: "" };

    if (textAlignment && TEXT_ALIGN[textAlignment]) classes["textAlignmentClass"] = `text-${TEXT_ALIGN[textAlignment]}`;

    if (horizontalAlignment)
        classes["horizontalAlignmentClass"] =
            `justify-content-${TEXT_ALIGN[horizontalAlignment] ? TEXT_ALIGN[horizontalAlignment] : horizontalAlignment}`; // Fallback, see why in Headline.js

    if (verticalAlignment) classes["verticalAlignmentClass"] = `align-items-${verticalAlignment}`;

    return classes;
};
